'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export function QueryProvider({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        // Data is considered fresh for 5 minutes
                        staleTime: 5 * 60 * 1000,
                        // Keep data in cache for 10 minutes (renamed from cacheTime in v5)
                        gcTime: 10 * 60 * 1000,
                        // Disable automatic refetching to reduce requests
                        refetchOnWindowFocus: false,
                        refetchOnReconnect: false,
                        refetchOnMount: true,
                        // Retry failed requests once
                        retry: 1,
                        retryDelay: 1000,
                    },
                    mutations: {
                        // Retry mutations once on failure
                        retry: 1,
                        retryDelay: 1000,
                    },
                },
            })
    );

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
